import { BID_DRAFT_ACTION_MODE } from "interfaces";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { CustomButton } from "ui";

import { BidDraftActionModal } from "./BidDraftActionModal";

export const DeclineDraftBidBtn = observer(() => {
  const { actionModals } = useStores();

  const openDeclineDraftModal = () => {
    actionModals.open(() => <BidDraftActionModal mode={BID_DRAFT_ACTION_MODE.DECLINE} />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      title: "Укажите причину отклонения",
      onApply: () => Promise.resolve(),
    });
  };

  return (
    <CustomButton type="default" onClick={openDeclineDraftModal} tooltip="Отклонить черновик заявки">
      Отклонить черновик
    </CustomButton>
  );
});
